import dynamic from 'next/dynamic'
import React, { ForwardedRef, forwardRef } from 'react'
import { Carousel } from 'lib/Carousel'
import { useBrandCarouselContext } from '../context/BrandCarouselContext'

const BrandCarouselItem = dynamic(() => import('../components/BrandCarouselItem').then((res) => res.BrandCarouselItem))
const BrandCarouselItemPlaceholder = dynamic(() => import('../components/BrandCarouselItem').then((res) => res.BrandCarouselItemPlaceholder))

export const BrandCarouselItemList = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  const { brands, loading } = useBrandCarouselContext()

  return (
    <Carousel ref={ref} itemWidth="320px">
      {brands && !loading && brands.map((brand, ix) => <BrandCarouselItem key={brand.id} brand={brand} lazyLoadImage={ix > 4} />)}
      {(!brands || loading) && Array.from({ length: 4 }, (_, ix) => <BrandCarouselItemPlaceholder key={`placeholder-${ix}`} />)}
    </Carousel>
  )
})

BrandCarouselItemList.displayName = 'BrandCarouselItemList'
